'use strict';
angular.module('far.club')
    .controller('ClubMembersListController', function ($filter, $log, $scope, $window, $http, form, autocomplete, userMembership, formsUtils, inviteUserForm, http) {
	var vm = {
	    progress: true,
            submitted: false,
            show_error: false,
            club_required: true,
            club_checkbox: false,
            max: null,
            club: null,
            users: [],
	    members_active:[],
	    members_active_paid:[],
            members_stopped:[],
            form: {},
            autoCompleteSelect: {
                country: null,
                region: null,
                city: null
            },
            submit: function () {
                vm.submitted = true;
                vm.show_error = true;

                if ( !$scope.membershipForm.$valid ) {
                   return false;
                }

            },
            constructor: function (user, club) {
		    vm.members_active =[];
		    vm.members_active_paid =[];
                    vm.members_stopped =[];
                    vm.members_new = [];
                    vm.members_invite = [];
                    vm.club = club;
		 

                    $http.get(Routing.generate('api_get_club_users', {club: vm.club}))
                        .then(function (response) {
				console.log(response);
			
                            response.data.forEach(function(clubUser) {
				
                                if ( clubUser.member_card && clubUser.member_date_end ) {
                                    clubUser.fio_desc += '         Действующий до ' + $filter('date')(clubUser.member_date_end, "dd-MM-yyyy");
                                        if (
                                            $filter('date')(clubUser.member_date_end, "yyyy") > $filter('date')(new Date(), "yyyy")
                                            || ($filter('date')(clubUser.member_date_end, "yyyy") == $filter('date')(new Date(), "yyyy") && ($filter('date')(new Date(), "M") != 11 && $filter('date')(new Date(), "M") != 12) )
                                        ) {
                                            clubUser.disabled = true;
						vm.members_active_paid.push(clubUser);
                                        }
					 else{
						   vm.members_active.push(clubUser);
					      }
					  }
				            else{
				                vm.members_active.push(clubUser);
				
				                }


                            });
                        //    vm.progress = false;
                        }, function errorCallback(response) {
                            $log.error(response);
                        });
            }
                 };

        return vm;
    });
